import React from "react";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaPlusCircle, FaTrashAlt, FaCopy } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
import { formatMoneyInputDisplay, parseMoneyInputChange, roundMoneyTwoDecimals, clampMoneyAmount, isValidMoneyInput, } from "../../../utils/money-input-helpers";
const autobind = require("class-autobind").default;
const rowWrapStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: "8px 12px",
};
export class FieldDeliveryFeeRange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            draftInputs: {},
        };
        autobind(this);
    }
    getDraftKey(i, key) {
        return `${i}:${key}`;
    }
    isValidDecimalInput(raw) {
        return isValidMoneyInput(raw);
    }
    setDraftInput(i, key, value) {
        const draftKey = this.getDraftKey(i, key);
        this.setState((prev) => ({
            draftInputs: {
                ...prev.draftInputs,
                [draftKey]: value,
            },
        }));
    }
    getDisplayInput(i, key, modelValue) {
        const draftKey = this.getDraftKey(i, key);
        const draft = this.state.draftInputs[draftKey];
        if (draft !== undefined)
            return draft;
        return formatMoneyInputDisplay(modelValue);
    }
    onMoneyChange(i, key, raw, optional) {
        if (!this.isValidDecimalInput(raw))
            return;
        this.setDraftInput(i, key, raw);
        if (raw === "") {
            if (optional)
                this.change(i, key, "");
            return;
        }
        if (raw.endsWith("."))
            return;
        const parsed = parseMoneyInputChange(raw);
        if (parsed !== "") {
            this.change(i, key, clampMoneyAmount(Number(parsed)));
        }
    }
    onMoneyBlur(i, key, optional, raw) {
        const trimmed = raw.trim();
        if (trimmed === "") {
            if (optional) {
                this.change(i, key, "");
                this.setDraftInput(i, key, "");
                return;
            }
            this.change(i, key, 0);
            this.setDraftInput(i, key, "0.00");
            return;
        }
        const rounded = clampMoneyAmount(roundMoneyTwoDecimals(parseFloat(trimmed) || 0));
        this.change(i, key, rounded);
        this.setDraftInput(i, key, rounded.toFixed(2));
    }
    add() {
        const values = [...this.props.values];
        values.push({
            up_to: 0,
            cost: 0,
            min_order: "",
        });
        this.setState({ draftInputs: {} });
        this.props.onChange(values);
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        values.push(value);
        this.setState({ draftInputs: {} });
        this.props.onChange(values);
    }
    remove(i) {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.setState({ draftInputs: {} });
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    render() {
        const { values, currencySymbol } = this.props;
        const sym = currencySymbol || "$";
        const units = this.props.kmmile === "KM" ? "kilometers" : "miles";
        return (React.createElement("div", null,
            values.length === 0 &&
                React.createElement(Button, { size: "xs", color: "primary-inverse", type: "button", onClick: this.add }, "Create Price Bracket"),
            values.length > 0 && (React.createElement("div", { className: "flex-line m-b-2", style: { flexWrap: "wrap", gap: "8px 12px", alignItems: "flex-end" } },
                React.createElement("div", { style: { width: "32px", minWidth: "32px", flexShrink: 0 }, "aria-hidden": true }),
                React.createElement("div", { style: { ...rowWrapStyle, marginBottom: 0 } },
                    React.createElement(FormGroup, { className: "m-b-0", title: `Distance (${units})`, small_title: true, no_border: true, style: { width: "120px", minWidth: "120px" } }),
                    React.createElement(FormGroup, { className: "m-b-0", title: `Cost (${sym})`, small_title: true, no_border: true, style: { width: "110px", minWidth: "110px" } }),
                    React.createElement(FormGroup, { className: "m-b-0", title: `Min Order (${sym})`, small_title: true, no_border: true, style: { width: "120px", minWidth: "120px" } }),
                    React.createElement(FormGroup, { className: "m-b-0", title: "Actions", small_title: true, no_border: true, style: { width: "110px", minWidth: "110px" } })))),
            React.createElement("div", null, values.map((item, i) => {
                return (React.createElement("div", { key: i, className: "flex-line m-t-3", style: { alignItems: "flex-end", flexWrap: "wrap", gap: "8px 12px" } },
                    React.createElement(InputBox, { className: "no-round width32 text-center" },
                        React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                    React.createElement("div", { style: rowWrapStyle },
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ?
                                `Between 0 to ${values[i].up_to || "X"} ${units}` :
                                `Between ${values[i - 1].up_to || "X"} to ${values[i].up_to || "X"} ${units}`, small_title: true, no_border: true, style: { width: "120px", minWidth: "120px" } },
                            React.createElement(Input, { placeholder: `Up to ${units}`, required: true, type: "number", step: 0.01, className: "no-round", style: { width: "100%" }, value: item.up_to, onChange: (e) => this.change(i, "up_to", parseFloat(e.target.value) || 0) })),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "110px", minWidth: "110px" } },
                            React.createElement(Input, { type: "text", inputMode: "decimal", required: true, className: "no-round", style: { width: "100%" }, value: this.getDisplayInput(i, "cost", item.cost), onChange: (e) => this.onMoneyChange(i, "cost", e.target.value, false), onBlur: (e) => this.onMoneyBlur(i, "cost", false, e.target.value) })),
                        React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "120px", minWidth: "120px" } },
                            React.createElement(Input, { type: "text", inputMode: "decimal", className: "no-round", style: { width: "100%" }, value: this.getDisplayInput(i, "min_order", item.min_order || ""), onChange: (e) => this.onMoneyChange(i, "min_order", e.target.value, true), onBlur: (e) => this.onMoneyBlur(i, "min_order", true, e.target.value) }))),
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end", flexShrink: 0, width: "110px", minWidth: "110px" } },
                        (this.props.values.length - 1) === i &&
                            React.createElement(Tooltip, { text: "Add", width: 65, position: "top" },
                                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: this.add },
                                    React.createElement(FaPlusCircle, null))),
                        React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                                React.createElement(FaTrashAlt, null))),
                        React.createElement(Tooltip, { text: "Copy", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                                React.createElement(FaCopy, null))))));
            }))));
    }
}
//# sourceMappingURL=index.js.map